import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
// import { MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-exam-schedule-dialog-box',
  templateUrl: './exam-schedule-dialog-box.component.html',
  styleUrls: ['./exam-schedule-dialog-box.component.scss']
})
export class ExamScheduleDialogBoxComponent implements OnInit {

  ExamSchForm: FormGroup;
  submitpayload: any;
  submitButton = true;
  editButton = false;
  public obj: any = {};
  showSubmitButton = true;
  list;
  isread = false;
  isreaddelete = false;
  APIService: any;
  deleteButton: boolean;
  dialogRef: MatDialogRef<any>;
  examList: any;
  filteredListExam: any;
  ExamName: any;
  ExamSFormArray;
  ImagePath: any;
  BranchList: any;
  filteredListBranch: any;
  examscheduleList: any;
  filteredListExamSch: any;
  ExamCode: any;
  userPermission: any;
  utp: any;
  ExCreate = true;
  ExUpdate = true;
  ExDelete = true;
  SessionNo: any;
  SnName;
  sessionList: any[] = [];
  filteredSessionList: any[] = [];

  constructor(
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    public dialogRef2: MatDialogRef<ExamScheduleDialogBoxComponent>,
    private fb: FormBuilder, public router: Router, private httpClient: HttpClient,
    private spinner: NgxSpinnerService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { this.APIService = environment.serviceUrl; }

  download() {
    const wwe = ['ShEmId', 'ShExtr1'];
  }

  ngOnInit(): void {
    if(JSON.parse(sessionStorage.getItem("session")) == null){
      this.fetchSecretData();
    }
    else if(JSON.parse(sessionStorage.getItem("session")) != null){
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo;
    }
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if (this.utp !== 'Super Admin' && this.utp !== 'Admin') {
      // this.isSuperAdmin= false;
      this.userPermission.forEach(element => {
        if (element.PageName == 'Exam-Schedule' && element.PCreate == false) {
          this.ExCreate = false;
        }
        if (element.PageName == 'Exam-Schedule' && element.PUpdate == false) {
          this.ExUpdate = false;
        }
        if (element.PageName == 'Exam-Schedule' && element.PDelete == false) {
          this.ExDelete = false;
        }
      });
    }
    window.scroll(0, 0);
    this.submitButton = true;
    this.editButton = false;
    this.deleteButton = false;
    this.list = true;
    this.ExamSchForm = this.fb.group({
      ShEmId: new FormControl('', Validators.required),
      ShExtr1: new FormControl(''),
      EmName: new FormControl(''),
      ShStatus: new FormControl('O'),
      ShPath: new FormControl(''),
      TempTextCheck: new FormControl(''),
      TempBranches: new FormControl(''),
      ShExtr2: new FormControl(''),
      ShMarks: new FormControl(''),
      ShId: new FormControl(''),
      ShSnNo: new FormControl(''),
    });
    this.fetchSessionList();

    this.fetchSecretData1();
    this.fetchExamData();
    this.fetchBranch();
    this.getExmSchData();
    this.loadsettingspage();
    
    if (this.data.key == "Edit") {
      this.prepopulation(this.data.selected);
    } else if (this.data.key == "Delete") {
      this.prepopulationForDelete(this.data.selected);
    } else {  
      // alert(this.data.key)
    }
  }
  fetchSessionList() {
    this.spinner.show();
    const payload = { SnActive: 'Y' };
    this.umsService.getSession(payload).subscribe({
      next: (res) => {
        this.spinner.hide();
        if (res.status) {
          this.sessionList = res.data || [];
          this.filteredSessionList = [...this.sessionList];
          if (this.SessionNo) {
            const defaultSession = this.sessionList.find(s => s.SnNo == this.SessionNo);
            if (defaultSession) {
              this.ExamSchForm.controls['ShSnNo'].setValue(this.SessionNo);
            } else if (this.sessionList.length > 0) {
              this.SessionNo = this.sessionList[0].SnNo;
              this.ExamSchForm.controls['ShSnNo'].setValue(this.SessionNo);
            }
          } else if (this.sessionList.length > 0) {
            this.SessionNo = this.sessionList[0].SnNo;
            this.ExamSchForm.controls['ShSnNo'].setValue(this.SessionNo);
          }
        } else {
          this.sessionList = [];
          this.filteredSessionList = [];
        }
      },
      error: (error: HttpErrorResponse) => {
        this.spinner.hide();
        this.sessionList = [];
        this.filteredSessionList = [];
      }
    });
  }
  onSessionChange(sessionId: any) {
    this.SessionNo = sessionId;
    this.ExamSchForm.controls['ShSnNo'].setValue(sessionId);
  }

  fetchSecretData1(){
    this.umsService.getSecretData().subscribe((res) => {
      this.ExamSchForm.controls['ShSnNo'].setValue(res.projectPharam['SnNo'])
      this.SnName = res.projectPharam['SnName']
      }
    );
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
      // this.ExamSchForm.controls['ShSnNo'].setValue(res.projectPharam['SnNo'])
      // this.SnName = res.projectPharam['SnName']
      }
    );
  }

  ngAfterViewInit(): void {
    // this.ngOnInit();
  }


  prepopulation(id) {
    this.editButton = true;
    this.isreaddelete = false;
    this.submitButton = false;
    this.isread = true;
    this.deleteButton = false;
    this.ExamSchForm = this.fb.group({
      ShEmId: new FormControl(id.ShEmId, Validators.required),
      ShExtr1: new FormControl(id.ShExtr1),
      EmName: new FormControl(id.EmName),
      ShStatus: new FormControl(id.ShStatus),
      ShPath: new FormControl(id.ShPath),
      TempTextCheck: new FormControl(id.TempTextCheck),
      TempBranches: new FormControl(id.TempBranches),
      ShExtr2: new FormControl(id.ShExtr2),
      ShMarks: new FormControl(id.ShMarks),
      ShId: new FormControl(id.ShId),
      ShSnNo: new FormControl(id.ShSnNo),
    });
  }

  deletee(e, k) {
    if (e === 'true') {
      this.list = false;
      this.prepopulationForDelete(k);
    } else {
      this.list = true;
    }
  }
  getExmSchData() {
    this.spinner.show();
    const payload = {};
    payload['LoginId'] = sessionStorage.getItem('userId');
    payload['ShSnNo'] = this.SessionNo
    this.umsService.getExmSch(payload).subscribe(res => {
      this.spinner.hide();
      this.examscheduleList = res.data;
      this.filteredListExamSch = this.examscheduleList.slice();
    });
  }
  prepopulationForDelete(id) {
    this.editButton = false;
    this.submitButton = false;
    this.isreaddelete = true;
    this.deleteButton = true;
    this.ExamSchForm = this.fb.group({
      ShEmId: new FormControl(id.ShEmId, Validators.required),
      ShExtr1: new FormControl(id.ShExtr1),
      EmName: new FormControl(id.EmName),
      ShStatus: new FormControl(id.ShStatus),
      ShPath: new FormControl(id.ShPath),
      TempTextCheck: new FormControl(id.TempTextCheck),
      TempBranches: new FormControl(id.TempBranches),
      ShExtr2: new FormControl(id.ShExtra2),
      ShMarks: new FormControl(id.ShMarks),
      ShId: new FormControl(id.ShId),
      ShSnNo: new FormControl(id.ShSnNo),
    });
  }

  DeletetheRecord() {
    const data = {};
    data['message'] = 'Are You Sure You Want To Delete This Record ?';
    data['title'] = 'Alert';
    data['icon'] = 'fa fa-question';
    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.deletedata(this.ExamSchForm.value);
        // this.dialogRef2.close();
      } else {
        // this.dialogRef2.close();
      }
    });
  }
  deletedata(id) {
    this.spinner.show();
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }), body: {
        ShEmId: id.ShEmId,
        ShExtr1: id.ShExtr1,
        EmName: id.EmName,
        ShStatus: id.ShStatus,
        ShPath: id.ShPath,
        TempBranches: id.TempBranches,
        ShExtr2: id.ShExtr2,
        ShMarks: id.ShMarks,
        ShId: id.ShId,
        ShSnNo: id.ShSnNo
      },
    };
    this.httpClient.delete(this.APIService + '/supervisor/ExamSchedule', options)
      .subscribe((s) => {
        this.spinner.hide();
        // this.spinner.hide();
        let cc = [];
        cc.push(s);
        let data = {}
        data['message'] = cc[0].message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          // this.ngOnInit();
          this.dialogRef2.close()
        });
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.ngOnInit();
        // this.umsService.openSnackbar(ERROR.error.message);

      });

  }

  submit() {
    if (this.ExamSchForm.invalid) {
      this.ExamSchForm.get('ShEmId').markAsTouched();
      return;
    } else {
      this.ExamSchedule();
    }
  }

  ExamSchedule() {
    this.spinner.show();
    this.submitpayload = this.ExamSchForm.value;
    this.umsService.addExmSch(this.submitpayload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.ngOnInit();
        });
      } else {
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        // this.dialogRef.afterClosed().subscribe((result) => {
        //   this.dialogRef2.close();
        // });
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      // this.dialogRef.afterClosed().subscribe(result => {
      //   this.ngOnInit();
      // });
    });
  }

  update() {
    if (this.ExamSchForm.invalid) {
      // this.ExamSchForm.get('ShEmId').markAsTouched();
      // this.ExamSchForm.get('ShExtr1').markAsTouched();
      return;
    } else {
      this.updateExamSchedule();
    }
  }

  updateExamSchedule() {
    this.spinner.show();
    this.submitpayload = this.ExamSchForm.value;
    this.umsService.updateExmSch(this.submitpayload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.ngOnInit();
        });
      } else {
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.dialogRef.afterClosed().subscribe(result => {
        this.ngOnInit();
      });
    });
  }

  editdata(e, k) {
    if (e === 'true') {
      this.list = false;
      this.prepopulation(k);
    } else {
      this.list = true;
    }
  }


  downloadMyFile() {
    this.spinner.show();
    const link = document.createElement('a');
    link.setAttribute('target', '_blank');
    link.setAttribute('href', '../../assets/SampleTemplate.csv');
    link.setAttribute('download', `Sample Template.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    this.spinner.hide();
  }
  redirect(to): void {
    this.router.navigate([to]);
  }




  fetchExamData() {
    const payload = {};
    payload['LoginId'] = sessionStorage.getItem('userId');

    this.umsService.ExmSchDD(payload).subscribe((res) => {
      if (res.status) {
        this.examList = res.data;
        this.filteredListExam = this.examList.slice();
      } else {
      }
    });
  }
  getExam(e) {
    this.ExamName = e.EmName;
    this.ExamCode = e.EmCode;
    this.ExamSchForm.controls['EmName'].setValue(e.EmName);
  }
  onFileSelect(input) {
    this.ImagePath = input.files[0]['name'];
    this.ExamSchForm.controls['ShPath'].setValue(this.ImagePath);
    if (input.files && input.files[0]) {
      var reader = new FileReader();
      reader.onload = (e: any) => {
        this.obj.photoUrl = e.target.result;
      }
      reader.readAsDataURL(input.files[0]);
    }
  }
  //   onFileSelect() {
  // const uploadButton = document.querySelector('#uploadButton');
  // uploadButton.addEventListener('click', () => {
  // const fileInput = document.createElement('input');
  // fileInput.type = 'file';
  // fileInput.addEventListener('change', () => {
  // });
  //  fileInput.click();
  // });
  //   }

  fetchBranch() {
    const payload = {};
    this.umsService.getExamStream(payload).subscribe(res => {
      if (res.status) {
        this.BranchList = res.data;
        this.filteredListBranch = this.BranchList.slice();
      } else {
      }
    })
  }

  prepopulatedatapage(e) {
    let payload = {};
    payload['FormPage'] = 'ExamSchedule';


    // this.ExamForm.controls['StuId'].setValue(e.data[0]['StuId']);
    this.umsService.getStdSetting(payload).subscribe((ress) => {
      ress.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            if (element.FormPattern == '') {
              this.ExamSchForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], Validators.required));
            }
            else {
              this.ExamSchForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], [Validators.required, Validators.pattern(element.FormPattern)]));
            }
          } else {
            this.ExamSchForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
          }
        } else {
          this.ExamSchForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
        }
      });
      this.mapdataaa(ress.data);
    });
  }

  loadsettingspage() {
    let payload = {};
    payload['FormPage'] = 'ExamSchedule';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      res.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            if (element.FormPattern == '') {
              this.ExamSchForm.addControl(element.FormControlName, new FormControl('', Validators.required));
            }
            else {
              this.ExamSchForm.addControl(element.FormControlName, new FormControl('', [Validators.required, Validators.pattern(element.FormPattern)]));
            }
          } else {
            this.ExamSchForm.addControl(element.FormControlName, new FormControl(''));
          }
        }
      });

      this.mapdataaa(res.data);
    });
  }
  mapdataaa(e) {
    this.ExamSFormArray = e.reduce(function (r, a) {
      r[a.FormControlName] = r[a.FormControlName] || [];
      r[a.FormControlName].push(a);
      return r;
    }, Object.create(null));
  }


  print(){
    this.submitpayload = this.ExamSchForm.value;
    let payload1 = {}
    payload1['MenuName'] ='Exam Schedule';
    payload1['InCode'] =0;
    payload1['StrTitle'] ='';
    payload1['StrSubTitle'] ='';
    payload1['SnName'] = this.SnName;
    let jsonString = JSON.stringify(payload1);
    var filter: any;
    filter = {
      "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
      "RptCode": 102,
      "InstName": '',
      "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
      "ShId": this.ExamSchForm.value['ShId'],
      "CgCode": '',
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId":  '',//this.emid
      "CsNo": '',
      "PgBreak": '',
      "StrId":  '', //this.submitpayload['strId'] ? this.submitpayload['strId'] : 0,
      "StrCode": '',
      "RgNo": '',
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": '', //this.submitpayload['course'] ? this.submitpayload['course'] : 0,
      "SnNo": this.SessionNo,
      "Extra1":jsonString
    }

    var payload: any;
    payload = filter;
    this.umsService.setData(JSON.stringify(payload));
    this.redirect('reports')
    this.dialogRef2.close();
  }

 
}